import { Box, IconButton, Menu, MenuItem, Toolbar, Typography, useTheme, } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ESmartwashLogo from '../../common/svg/logo';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { theme } from '../../theme';
import "./style.css"

// icons

import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';

interface Route {
    name: string;
    url: string;
}

const routes: Route[] = [
    { name: 'Home', url: '/' },
    { name: 'Pricing', url: '/pricing/' },
    { name: 'Loyalty program', url: '/loyalty-program/' },
    { name: 'About', url: '/about/' },
    { name: 'Blog', url: '/blog/' },
    { name: 'Contact', url: '/contact/' },
];


const mobileRoutes: Route[] = [
    ...routes,
    { name: 'Call Now', url: 'tel:022-529-7734' },
    { name: 'Email Us', url: 'mailto:admin@e-smartwash.co.nz' },
];

const underlineEffect: object = {
    position: 'relative',
    '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: '-3px',
        width: '0px',
        height: '2px',
        backgroundColor: theme.palette.primary.dark,
        transition: 'width 0.3s ease'
    },
    '&:hover': {
        color: theme.palette.primary.dark,
    },
    '&:hover:after': {
        width: '100%',
    }
};

const NavigationMenu = () => {
    return (
        <Box className="main-menu" sx={{ display: 'flex', gap: 2, marginLeft: 'auto', }}>
            {routes.map((route) => (
                <Link
                    to={route.url}
                    key={route.name}
                    style={{ textDecoration: 'none' }}
                >
                    <Typography
                        variant='button'
                        fontWeight={600}
                        color={theme.palette.primary.main}
                        sx={{
                            display: 'inline-block',
                            minWidth: 'max-content',
                            ...underlineEffect
                        }}
                    >
                        {route.name}
                    </Typography>
                </Link>
            ))}
        </Box>
    );
};

const ContactButtons = () => {
    const contactInfo = [
        {
            icon: <CallIcon />,
            href: "tel:022-529-7734",
            text: "022-529-7734"
        },
        {
            icon: <EmailIcon />,
            href: "mailto:admin@e-smartwash.co.nz",
            text: "admin@e-smartwash.co.nz"
        }
    ];

    return (
        <Box sx={{
            display: 'flex',
            gap: 1,
            listStyle: 'none',
            ml: 2
        }}>
            {contactInfo.map((item, index) => (
                <Box
                    key={index}
                    component="a"
                    href={item.href}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontWeight: '600',
                        textDecoration: 'none',
                        minWidth: 'max-content',
                        color: theme.palette.primary.main,
                        '& .MuiSvgIcon-root': {
                            color: theme.palette.primary.main
                        },
                        ...underlineEffect
                    }}
                >
                    {item.icon}
                    {item.text}
                </Box>
            ))}
        </Box>
    );
};



export const HeaderComponents = () => {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Toolbar disableGutters>
            <Box my={theme.spacing(2)} component={'a'} href='/'>
                <ESmartwashLogo />
            </Box>

            <Box className="header-menu" sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, gap: 2 }} >
                <NavigationMenu />
                <ContactButtons />
            </Box>
            <Box
                sx={{
                    flexGrow: 1,
                    justifyContent: 'flex-end',
                    display: { xs: 'flex', md: 'none' },
                }}
            >
                <IconButton
                    size='large'
                    aria-label='account of current user'
                    aria-controls='menu-appbar'
                    aria-haspopup='true'
                    onClick={handleMenu}
                    color='inherit'
                >
                    <MenuIcon />
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {mobileRoutes.map((route) => (
                        <MenuItem key={route.name}>
                            <Link to={route.url} key={route.name} onClick={handleClose} style={{ textDecoration: 'none', color: theme.palette.primary.main, fontWeight: '600' }}> {route.name} </Link>
                        </MenuItem>
                    ))}
                </Menu>
            </Box>
        </Toolbar>
    )
}
